/**
 * CN： 中国
 * 
 * SG： 新加坡
 * 
 * HK： 香港
 * 
 * TW： 台湾
 */
 export enum AreaEnum {
  CN = '+86',
  SG = '+65',
  HK = '+852',
  TW = '+886',
}

export const AREACODE: IAreaCode = {
  [AreaEnum.CN]: { area: '中国',tip:'中国大陆区号', reg: /^1[3456789]\d{9}$/ },
  [AreaEnum.SG]: { area: '新加坡',tip:'新加坡区号', reg: /^[89]\d{7}$/ },
  [AreaEnum.HK]: { area: '香港',tip:'中国香港区号', reg: /^[69]\d{7}$/ },
  [AreaEnum.TW]: { area: '台湾',tip:'中国台湾区号', reg: /^09\d{8}$/ },
};

export type IAreaCode = {
  [code in AreaEnum]: {
    area: string;
    reg: RegExp;
    tip:string
  };
};

export interface IMobileInfo {
  areaCode: AreaEnum;
  phoneNum: string;
}

export interface IMobileRef {
  getValidateRes: () => { res: boolean; mobileInfo: IMobileInfo };
}

